import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import i18n from '../locales/i18n'
import Home from '../views/home/Home.vue'
import Room from '@/views/program/Room'
import Camera from '@/views/program/Camera'
import ContentWrapper from '@/views/program/ContentWrapper'
import Library from '@/views/program/Library'
import LibraryContent from '@/views/program/LibraryContent'
import Presentation from '@/views/program/Presentation'
import Image from '@/views/program/Image'
import Video from '@/views/program/Video'
import Questions from '@/views/program/Questions'
import { setLanguage, getLanguage } from '@/utils/language-utils';

const SUPPORTED_LANGS = ['en', 'gr', 'es']

function resolveStoredLang() {
  const stored = getLanguage()
  return SUPPORTED_LANGS.includes(stored) ? stored : 'en'
}

import LiveRoom from '@/views/live/LiveRoom'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
    .catch(err => {
      if (err.name != "NavigationDuplicated") {
        throw err;
      }
    })
};

const routes = [
  {
    path: '/',
    redirect: () => `/${resolveStoredLang()}`
  },
  {
    path: '/:lang',
    component: Home,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage
      }else {
        i18n.locale = 'en';
      }
      
      next();
    }
  },
  {
    path: '/:lang/live',
    name: "liveRoom",
    component: LiveRoom,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage
      }else {
        i18n.locale = 'en';
      }
      
      next();
    }
  },
  {
    path: '/:lang/room',
    component: Room,
    beforeEnter(to, from, next) {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage
      }else {
        i18n.locale = 'en';
        return next('/en');
      }



      if (store.state.twilio.room) {
        next();
      } else {
        next(`/${lang}`); // redirect πίσω στην αρχική με γλώσσα
      }
    },
    children: [
      {
        path: "/",
        redirect: 'camera'
      },
      {
        path: 'camera',
        component: Camera
      },
      {
        path: 'content',
        component: ContentWrapper,
        children: [
          {
            path: "/",
            redirect: 'library'
          },
          {
            path: 'library',
            component: Library,
            children: [
              {
                path: "/",
                component: LibraryContent
              },
              {
                path: "image/:id",
                component: Image,
                beforeEnter(to, from, next) {
                  store.commit("setOpenedContentFromLibrary", to.params.id);

                  if (store.state.guide.openedContent) {
                    next();
                  } else {
                    next(`/${i18n.locale}/room/content/library`);
                  }
                },
              },
              {
                path: "video/:id",
                component: Video,
                beforeEnter(to, from, next) {
                  store.commit("setOpenedContentFromLibrary", to.params.id);

                  if (store.state.guide.openedContent) {
                    next();
                  } else {
                    next(`/${i18n.locale}/room/content/library`);
                  }
                },
              }
            ]
          },
          {
            path: 'presentation',
            component: Presentation,
            children: [
              {
                path: "/",
                redirect: to => {
                  return `/${i18n.locale}/room/content/presentation/${store.state.guide.presentationActiveFile?.type}/${store.state.guide.presentationActiveFile?.id}`
                }
              },
              {
                path: "image/:id",
                component: Image,
                beforeEnter(to, from, next) {
                  store.commit("setOpenedContentFromPresentation");

                  if (store.state.guide.openedContent) {
                    next();
                  } else {
                    next(`/${i18n.locale}/room/content/camera`);
                  }
                },
              },
              {
                path: "video/:id",
                component: Video,
                beforeEnter(to, from, next) {
                  store.commit("setOpenedContentFromPresentation");

                  if (store.state.guide.openedContent) {
                    next();
                  } else {
                    next(`/${i18n.locale}/room/content/camera`);
                  }
                },
              }
            ]
          },
          {
            path: 'questions',
            component: Questions
          }
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: () => {
      // PWA start_url "/" και άγνωστα paths: χρησιμοποίησε γλώσσα από localStorage (από /gr κ.λπ.)
      const lang = resolveStoredLang()
      return `/${lang}/room/camera`
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
